import {
  Component,
  OnInit,
} from '@angular/core';

import { DeveloperService } from './services/developer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'sk-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss'],
})
export class DeveloperComponent implements OnInit {
  constructor(
    readonly developerService: DeveloperService,
    readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.developerService.getPartnerInfo().subscribe({
      next: x => {
        const devApiUrl = x.result.ApimDeveloperPortalUrl;
        if (x.result.IsApiDeveloper && !!devApiUrl) {
          window.location.href = devApiUrl;
        } else {
          console.error('Developer API: Error with current User or ApimDeveloperPortalUrl');
          this.router.navigate(['/']);
        }
      },
      error: () => {
        console.error('Developer API: Error during the call to DeveloperService');
        this.router.navigate(['/']);
      }
    });
  }
}
